<div class="flex justify-content-center align-items-center h-screen">
  <p-progressSpinner styleClass="mt-4" strokeWidth="4"
    >Logging out...</p-progressSpinner
  >
</div>
